import React from "react";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import { DragPreview } from "./role-management-modal";

interface RoleDragPreviewProps {
  dragPreview: DragPreview | null;
}

export const RoleDragPreview: React.FC<RoleDragPreviewProps> = ({ dragPreview }) => {
  if (!dragPreview) return null;

  return (
    <div
      className="role-drag-preview-floating"
      style={{
        position: "fixed",
        pointerEvents: "none",
        zIndex: 10000,
        transform: `translate(${dragPreview.x}px, ${dragPreview.y}px)`
      }}
    >
      <div className="role-drag-preview-content">
        <KuikaSvg name="key" width={16} height={16} />
        <span>{dragPreview.role.name}</span>
      </div>
    </div>
  );
};
